import { useSelector, useDispatch } from "react-redux";

export const useFilters = (stateSelector, dispatchCallback) => {
  const filters = useSelector((state) => state[stateSelector]);
  const dispatch = useDispatch();
  const updateFilters = (v) => dispatch(dispatchCallback(v));
  return [filters, updateFilters] as const;
};
